export default ['0px', '4px', '8px', '16px', '100%'];
